import lozad from 'lozad';

export let loadAssets = {
    
    selector : '.lazy',
    observer : null,

    load : function(selector = this.selector) {

        // lazy loading using lozad.js, https://github.com/ApoorvSaxena/lozad.js
        this.observer = lozad(selector); // lazy loads elements with default selector as '.lozad'
        this.observer.observe();

    }
}